window.app.controller('partnerPageCtrl', ['$scope', '$http', '$compile', function ($scope, $http, $compile) {
    
    $scope.offersViewCtrl = () => {
        let offers = $('.tabCategoryOffers');
        let ctrlBtns = $('.categoryTabsCTRL');

        ctrlBtns.first().addClass('open');
        offers.first().show();

        if(offers.length == 1){
            $('.categoryTabsCTRL').hide()
        }
        if(offers.length == 0){
            $('.categoryTabsCTRL').hide();
            $('.no-offers-msg').show();
        }
        else{
            let urlArr = window.location.pathname.split('/').length;
            if(urlArr > 3){
                $scope.openCategoryTab();
            }
            
        }
    }
    $scope.openCategoryTab = () => {
        let urlArr = window.location.pathname.split('/');
        let category = urlArr[urlArr.length - 2];
        let categoryTab = $(`.categoryTabsCTRL[data-ctrl="${category}"]`);
        let categoryBody = $(`.tabCategoryOffers[data-content="${category}"]`);
        $(`.categoryTabsCTRL`).removeClass('open');
        $(`.tabCategoryOffers`).hide();
        categoryTab.addClass('open');
        categoryBody.show();

        console.log(categoryTab)

    }
    
    $scope.offersViewCtrl();
    
}]);


// WEBPACK FOOTER //
// src/js/controllers/partner/pageCtrl.js